export const userNameErrorMessage = "Please enter username";
export const passwordErrorMessage = "Please enter password";
